/**
 * Toolbar Component
 *
 * Header toolbar containing branding and search field.
 */

/**
 * Toolbar provides the header UI with branding and action containers.
 */
export class Toolbar {
  /**
   * Create toolbar
   * @param {string|HTMLElement} container - Container element or ID
   */
  constructor(container) {
    this.container =
      typeof container === 'string'
        ? document.getElementById(container)
        : container;

    this.element = null;
    this.searchContainer = null;
    this.actionsContainer = null;

    this.render();
  }

  /**
   * Render the toolbar
   */
  render() {
    this.element = document.createElement('header');
    this.element.className = 'toolbar';
    this.element.innerHTML = `
      <div class="toolbar-brand">
        <span class="toolbar-logo">🧬</span>
        <span class="toolbar-title">MeCell Maps</span>
      </div>
      <div class="toolbar-search"></div>
      <div class="toolbar-actions"></div>
    `;

    this.searchContainer = this.element.querySelector('.toolbar-search');
    this.actionsContainer = this.element.querySelector('.toolbar-actions');

    this.container.prepend(this.element);
  }

  /**
   * Get the search container element
   * @returns {HTMLElement}
   */
  getSearchContainer() {
    return this.searchContainer;
  }

  /**
   * Get the actions container element
   * @returns {HTMLElement}
   */
  getActionsContainer() {
    return this.actionsContainer;
  }

  /**
   * Get the toolbar element
   * @returns {HTMLElement}
   */
  getElement() {
    return this.element;
  }
}
